<template>
  <main class="website-main">
    <div class="gradient-top">
      <v-section-about-me-detail />
      <v-section-how-i-can-help-you />
    </div>
    <div class="gradient-bottom">
      <v-section-my-story />
      <v-section-cooperation />
      <v-card-reference />
    </div>
  </main>
</template>

<script setup>
import { onMounted, defineProps, computed } from 'vue'
import { useMicrositeStore } from '../stores/useMicrositeStore'
import VCardReference from '../components/v-card/VCardReference.vue'
import VSectionAboutMeDetail from '../components/v-section/VSectionAboutMeDetail.vue'
import VSectionHowICanHelpYou from '../components/v-section/VSectionHowICanHelpYou.vue'
import VSectionMyStory from '../components/v-section/VSectionMyStory.vue'
import VSectionCooperation from '../components/v-section/VSectionCooperation.vue'

const props = defineProps({
  microsite: {
    type: Object,
    required: true
  }
})

const micrositeStore = useMicrositeStore()

onMounted(() => {
  micrositeStore.setMicrosite(props.microsite)
})

const store = useMicrositeStore()

/**
 * Computed property for generating the proper URL for the about image.
 *
 * If the microsite has a custom photo URL, it replaces "/media/" with
 * "/media/cache/about_me/" and strips any trailing slash. Otherwise, it
 * falls back to a dummy image.
 *
 * @returns {string} The final image URL.
 */
const aboutMePhoto = computed(() => {
  const photoUrl = store.microsite?.aboutMePhoto
  if (photoUrl) {
    // Replace the base path and remove a trailing slash, if any.
    return photoUrl
      .replace('/media/', '/media/cache/about_me/')
      .replace(/\/$/, '')
  }
  return 'https://dummyimage.com/1200x1200/000/d90d83.png'
})

</script>
